import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {IRolesGroups, TaskModel} from '../../../models/task.model';
import {HelpersService} from '../../../services/helpers.service';
import {MemberService} from '../../../services/member.service';
import {from, map, Observable, of, Subscription, switchMap} from 'rxjs';

@Component({
    selector: 'app-task-users-list',
    templateUrl: './task-users-list.html',
    styleUrls: ['./task-users-list.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppTaskUsersList {
    public showRoles = true
    public taskData: TaskModel;
    public is_project_admin: boolean;
    private subscriptions = new Subscription

    constructor(
        public helpersService: HelpersService,
        public memberService: MemberService,
        private changeDetectorRef: ChangeDetectorRef
    ) {
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe()
    }

    ngOnInit(): void {
        this.subscriptions.add(this.getUserData().subscribe(data => {
            this.taskData.roles = data
            this.changeDetectorRef.detectChanges()
        }));
    }

    getUserData(): Observable<IRolesGroups> {
        let memberGuids: string[] = []
        Object.values(this.taskData.roles).forEach((members: any) => {
            memberGuids = memberGuids.concat(members);
        });
        memberGuids.push(this.taskData.author_guid);
        let roles = structuredClone(this.taskData.roles)
        return from(this.memberService.memberGuidsHandler(memberGuids)).pipe(
            map(members =>
                Object.keys(roles).forEach((role) => roles[role] = roles[role]
                    .map(guid => {
                        return members.find(member => member.guid === guid)
                    }))),
            switchMap(() => of(roles)))
    }

    profile(userId: string): void {
        this.helpersService.openProfileByGuid(userId);
    }
}
